export var WindowType;
(function (WindowType) {
    WindowType[WindowType["child"] = 0] = "child";
    WindowType[WindowType["main"] = 1] = "main";
    WindowType[WindowType["mdi"] = 2] = "mdi";
    WindowType[WindowType["mdihelp"] = 3] = "mdihelp";
    WindowType[WindowType["popup"] = 4] = "popup";
    WindowType[WindowType["response"] = 5] = "response";
})(WindowType || (WindowType = {}));
